import { render, staticRenderFns } from "./form-success-modal.vue?vue&type=template&id=bfaea47c&"
import script from "./form-success-modal.vue?vue&type=script&lang=js&"
export * from "./form-success-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports